/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useContext, useRef } from "react";
import ReactToPrint from "react-to-print";
import moment from "moment";
import { Button } from "@repo/ui";
import { UserContext } from "utils/reducers/user";
import logo from "assets/images/tg-logo.png";
import ImagePreview from "./imagePreview";

export default function EvhrPrint({
  slipData,
  closeModel,
  consignmentsDetail,
  type,
  isResidual,
  isPackedCollection
}: any) {
  const user = useContext(UserContext);
  const nf = Intl.NumberFormat();

  let componentRef: any = useRef();

  const closePrintModel = () => {
    closeModel(false);
  };

  return (
    <>
      <div style={{ display: "none" }}>
        <ComponentToPrint
          slipData={slipData}
          nf={nf}
          type={type}
          isResidual={isResidual}
          isPackedCollection={isPackedCollection}
          ref={(el) => (componentRef = el)}
          userDetails={user}
          consignmentsDetail={consignmentsDetail}
        />
      </div>

      <ReactToPrint
        trigger={() => {
          return <Button>Print EVHR</Button>;
        }}
        content={() => componentRef}
        pageStyle="print"
        onAfterPrint={closePrintModel}
        documentTitle={`${consignmentsDetail?.vhrType} EVHR`}
      />
    </>
  );
}

class ComponentToPrint extends React.Component<any> {
  constructor(props: any) {
    super(props);

    this.state = {
      data: []
    };
  }
  componentDidMount() {
    this.setState({ data: this.payload() });
  }
  payload = () => {
    let _result = [];
    const propsData: any = this.props;

    const fieldTeam = propsData?.consignmentsDetail?.fieldTeam || [];
    let teamLeader = { name: "", employeeId: "", nationality: "" };
    let guard = { name: "", employeeId: "", nationality: "" };
    let driver = { name: "", employeeId: "", nationality: "" };
    let tempArray = fieldTeam.filter((elm: any) => elm.role === "Team Leader");
    if (tempArray.length > 0) {
      teamLeader = tempArray[0];
    }
    tempArray = fieldTeam.filter((elm: any) => elm.role === "Guard");
    if (tempArray.length > 0) {
      guard = tempArray[0];
    }
    tempArray = fieldTeam.filter((elm: any) => elm.role === "Driver");
    if (tempArray.length > 0) {
      driver = tempArray[0];
    }

    const isTGDelivery = propsData?.consignmentsDetail?.isTGDelivery;
    const deliveryBags = propsData?.consignmentsDetail?.containers;
    const collectedBags =
      propsData?.slipData?.deliveredConsignments?.containers || [];

    const collectedFcTotalValueList =
      propsData?.slipData?.deliveredConsignments?.fcList || [];
    const fcTotalValueList = propsData?.consignmentsDetail?.fcList || [];

    let totalConsignments: any = 0;
    let totalCollectedCoins: any = 0;
    let totalDeliveredConsignments: any = 0;
    let totalDeliveredCoins: any = 0;
    let _fcInformation: any = [];
    let _deliveredFcInformation: any = [];
    let _bagsInformation: any = isTGDelivery
      ? []
      : [
          {
            label:
              propsData?.consignmentsDetail?.vhrType === "Delivery"
                ? "From"
                : "To",
            value:
              propsData?.consignmentsDetail?.vhrType === "Delivery"
                ? `${propsData?.consignmentsDetail?.sourceLocationId}-${propsData?.consignmentsDetail?.sourceLocationBarcode}`
                : `${propsData?.consignmentsDetail?.onwardLocationId}-${propsData?.consignmentsDetail?.onwardLocationBarcode}`
          }
        ];

    let deliveredBagsInformation: any = [
      {
        label: "From",
        value: `${propsData?.consignmentsDetail?.onwardLocationId}-${propsData?.consignmentsDetail?.onwardLocationBarcode}`
      }
    ];

    fcTotalValueList?.forEach((element: any) => {
      _fcInformation = _fcInformation.concat([
        {
          label: `${element?.currency} ${propsData?.nf.format(element.declaredValue || 0)}`,
          value: ""
        }
      ]);
    });

    collectedFcTotalValueList?.forEach((element: any) => {
      _deliveredFcInformation = _deliveredFcInformation.concat([
        {
          label: `${element?.currency} ${propsData?.nf.format(element.declaredValue || 0)}`,
          value: ""
        }
      ]);
    });

    deliveryBags?.forEach((element: any) => {
      const fcList =
        element.packedCurrencies?.map((itm: any) => ({
          label: `${itm.currency} ${propsData?.nf.format(itm.declaredValue || 0)}`,
          value: ``
        })) || [];
      totalConsignments = totalConsignments + element.count;
      if (element.consignmentType === "Coins") {
        totalCollectedCoins = totalCollectedCoins + element.declaredValue;
      }

      _bagsInformation = _bagsInformation.concat([
        ...(isTGDelivery
          ? [
              {
                label:
                  propsData?.consignmentsDetail?.vhrType === "Delivery"
                    ? "From"
                    : "To",
                value: `${element?.sourceLocationBarcode}-${element?.sourceLocationId}`
              }
            ]
          : [{}]),
        {
          label: `${element.sealNo || element.details} (${element.containerType})`,
          value: ""
        },
        ...(fcList?.length
          ? fcList
          : [
              {
                label: `${element.currency} ${propsData?.nf.format(element.declaredValue || 0)}`,
                value: ``
              }
            ]),
        {
          label: `Count`,
          value: `${element.count}`
        },
        ...(element?.chequePieces
          ? [
              {
                label: `Cheque Pieces`,
                value: `${element?.chequePieces}`
              }
            ]
          : []),
        ...(element.remarks
          ? [
              {
                label: `Remarks`,
                value: `${element.remarks}`
              }
            ]
          : [])
      ]);
    });

    collectedBags?.forEach((element: any) => {
      const fcList =
        element.packedCurrencies?.map((itm: any) => ({
          label: `${itm.currency} ${propsData?.nf.format(itm.declaredValue || 0)}`,
          value: ``
        })) || [];
      totalDeliveredConsignments = totalDeliveredConsignments + element.count;
      if (element.consignmentType === "Coins") {
        totalDeliveredCoins = totalDeliveredCoins + element.declaredValue;
      }
      deliveredBagsInformation = deliveredBagsInformation.concat([
        {
          label: `${element.sealNo || element.details} (${element.containerType})`,
          value: ""
        },
        ...(fcList?.length
          ? fcList
          : [
              {
                label: `${element.currency} ${propsData?.nf.format(element.declaredValue || 0)}`,
                value: ``
              }
            ]),
        {
          label: `Count`,
          value: `${element.count}`
        },
        ...(element?.chequePieces
          ? [
              {
                label: `Cheque Pieces`,
                value: `${element?.chequePieces}`
              }
            ]
          : []),
        ...(element.remarks
          ? [
              {
                label: `Remarks`,
                value: `${element.remarks}`
              }
            ]
          : [])
      ]);
    });

    let _csr = {
      name: "",
      mobileNo: "",
      employeeId: "",
      signature: "",
      signatureDate: ""
    };
    if (propsData?.consignmentsDetail?.siteRepresentatives.length > 0) {
      _csr = propsData?.consignmentsDetail?.siteRepresentatives[0];
    }

    _result = [
      {
        label: "TRANSGUARD",
        value: "",
        type: "heading",
        style: {
          font: "normal normal bold 50px/70px DM Sans, arial"
        }
      },
      {
        label: "Electronic Valuable Handling Receipt",
        value: ""
      },
      {
        label: "Receipt No",
        value: propsData?.consignmentsDetail?.vhrNo
      },
      {
        label: "Service Date",
        value: propsData?.consignmentsDetail?.locationArrivalTime?.split(" ")[0]
      },
      {
        label: "Site Arrival Time",
        value: `${propsData?.consignmentsDetail?.locationArrivalTime?.split(" ")[1]} ${propsData?.consignmentsDetail?.locationArrivalTime?.split(" ")[2]}`
      },
      {
        label: "Service Completion Time",
        value: `${propsData?.consignmentsDetail?.serviceCompletionTime?.split(" ")[1]} ${propsData?.consignmentsDetail?.serviceCompletionTime?.split(" ")[2]}`
      },
      {
        label: "Route ID",
        value: propsData?.consignmentsDetail?.routeNo
      },
      {
        label: "Vehicle #",
        value: propsData?.consignmentsDetail?.vanRegistrationNo
      },
      {
        label: "Customer",
        value:
          propsData?.slipData?.billingCustomerName ||
          propsData?.slipData?.customer
      },
      {
        label: "Location ID",
        value:
          propsData?.consignmentsDetail?.vhrType === "Delivery" &&
          propsData?.type === "B2B"
            ? propsData?.slipData?.onwardLocationId
            : propsData?.type === "B2B"
              ? propsData?.slipData?.sourceLocationId
              : propsData?.isResidual ||
                  (propsData?.consignmentsDetail?.vhrType === "Delivery" &&
                    propsData?.type === "InterBranch")
                ? propsData?.consignmentsDetail?.onwardLocationId
                : propsData?.type === "InterBranch"
                  ? propsData?.consignmentsDetail?.sourceLocationId
                  : propsData?.isPackedCollection
                    ? propsData?.consignmentsDetail?.sourceLocationId
                    : propsData?.slipData?.locationId
      },
      {
        label: "Barcode",
        value:
          propsData?.consignmentsDetail?.vhrType === "Delivery" &&
          propsData?.type === "B2B"
            ? propsData?.slipData?.onwardLocationBarcode
            : propsData?.type === "B2B"
              ? propsData?.slipData?.sourceLocationBarcode
              : propsData?.isResidual ||
                  (propsData?.consignmentsDetail?.vhrType === "Delivery" &&
                    propsData?.type === "InterBranch")
                ? propsData?.consignmentsDetail?.onwardLocationBarcode
                : propsData?.type === "InterBranch"
                  ? propsData?.consignmentsDetail?.sourceLocationBarcode
                  : propsData?.isPackedCollection
                    ? propsData?.consignmentsDetail?.sourceLocationBarcode
                    : propsData?.slipData?.barcode
      },
      {
        label: "Service Point",
        value:
          propsData?.consignmentsDetail?.vhrType === "Delivery" &&
          propsData?.type === "B2B"
            ? propsData?.slipData?.onwardLocationName
            : propsData?.type === "B2B"
              ? propsData?.slipData?.sourceLocationName
              : propsData?.isResidual ||
                  (propsData?.consignmentsDetail?.vhrType === "Delivery" &&
                    propsData?.type === "InterBranch")
                ? propsData?.consignmentsDetail?.onwardLocationName
                : propsData?.type === "InterBranch"
                  ? propsData?.consignmentsDetail?.sourceLocationName
                  : propsData?.isPackedCollection
                    ? propsData?.consignmentsDetail?.locationName
                    : propsData?.slipData?.locationName
      },
      ...(propsData?.slipData?.serviceType === "Exchange Service"
        ? [
            {
              label: "Service Type",
              value: propsData?.slipData?.jobType,
              style: { marginBottom: "25px" }
            }
          ]
        : [
            {
              style: { marginBottom: "25px" }
            }
          ]),
      ...(((propsData?.slipData?.deliveredConsignments?.containers?.length &&
        !propsData?.slipData?.deliveredConsignments?.vhrNo) ||
        (propsData?.type === "Exchange" &&
          propsData?.slipData?.deliveredConsignments?.vhrNo ===
            propsData?.consignmentsDetail?.vhrNo &&
          propsData?.slipData?.collectedConsignments?.length)) &&
      propsData?.consignmentsDetail?.vhrEditType === "Main Collection"
        ? [
            {
              label: "Total Delivered",
              value: totalDeliveredConsignments,
              type: "heading",
              style: { marginTop: "25px", fontWeight: 600 }
            },

            ...deliveredBagsInformation,
            ...(totalDeliveredCoins
              ? [
                  {
                    label: "Coins Total Values (Delivered)",
                    value: ``,
                    style: { marginTop: "25px", fontWeight: 600 }
                  },
                  {
                    label: `AED ${propsData?.nf.format(totalDeliveredCoins || 0)}`,
                    value: ""
                  }
                ]
              : []),
            ...(propsData?.slipData?.deliveredConsignments?.lcTotalValue -
              totalDeliveredCoins >
            0
              ? [
                  {
                    label: "Total Values (Delivered)",
                    value: ``,
                    style: { fontWeight: 600 }
                  },
                  {
                    label: `AED ${propsData?.nf.format(propsData?.slipData?.deliveredConsignments?.lcTotalValue - totalDeliveredCoins || 0)}`,
                    value: ""
                  }
                ]
              : []),
            ..._deliveredFcInformation
          ]
        : []),
      ...(propsData?.slipData?.markedPending &&
      !propsData?.consignmentsDetail?.containers?.length
        ? [
            {
              label: "Service Marked Pending",
              value: ""
            },
            {
              label: "Pending Reason",
              value: propsData?.slipData?.pendingReason || "N/A"
            },
            {
              label: "Pending Remarks",
              value: propsData?.slipData?.pendingRemarks || "N/A"
            }
          ]
        : [
            ...(propsData?.consignmentsDetail?.containers?.length
              ? [
                  {
                    label:
                      propsData?.consignmentsDetail?.vhrType === "Delivery"
                        ? "Total Delivered"
                        : "Total Collected",
                    value: totalConsignments,
                    type: "heading",
                    style: { marginTop: "25px" }
                  },
                  ..._bagsInformation,
                  ...(totalCollectedCoins
                    ? [
                        {
                          label: `Coins Total Values (${propsData?.consignmentsDetail?.vhrType === "Delivery" ? "Delivered" : "Collected"})`,
                          value: ``,
                          style: { marginTop: "25px", fontWeight: 600 }
                        },
                        {
                          label: `AED ${propsData?.nf.format(totalCollectedCoins || 0)}`,
                          value: ""
                        }
                      ]
                    : []),
                  ...(propsData?.consignmentsDetail?.lcTotalValue -
                    totalCollectedCoins >
                  0
                    ? [
                        {
                          label: `Total Values (${propsData?.consignmentsDetail?.vhrType === "Delivery" ? "Delivered" : "Collected"})`,
                          value: ``,
                          style: { fontWeight: 600 }
                        },
                        {
                          label: `AED ${propsData?.nf.format(propsData?.consignmentsDetail?.lcTotalValue - totalCollectedCoins || 0)}`,
                          value: ""
                        }
                      ]
                    : []),
                  ..._fcInformation
                ]
              : [])
          ]),

      ...(_csr.signature || _csr.name || _csr.employeeId
        ? [
            {
              label: `Site Representative`,
              value: "",
              type: "heading",
              style: { marginTop: "25px" }
            }
          ]
        : [
            {
              style: { marginTop: "25px" }
            }
          ]),
      ...(_csr.employeeId
        ? [
            {
              label: "Emirates ID",
              value: _csr.employeeId
            }
          ]
        : []),
      ...(_csr.name
        ? [
            {
              label: "ID or Name",
              value: _csr.name
            }
          ]
        : []),
      ...(_csr.mobileNo
        ? [
            {
              label: "Mobile",
              value: _csr.mobileNo
            }
          ]
        : []),
      ...(_csr.signature
        ? [
            {
              label: "Customer Signature",
              value: "",
              image: <ImagePreview path={_csr.signature} />
            },
            {
              label: "Date",
              value: _csr.signatureDate,
              style: { marginBottom: "25px" }
            }
          ]
        : [
            {
              style: { marginBottom: "25px" },
              label: ""
            }
          ]),

      {
        label: `Field Team:`,
        value: "",
        type: "heading"
      },
      {
        label: `${teamLeader.name}-${teamLeader.employeeId}`,
        value: ""
      },
      {
        label: `${driver.name}-${driver.employeeId}`,
        value: ""
      },
      {
        label: `${guard.name}-${guard.employeeId}`,
        value: ""
      },
      propsData?.consignmentsDetail?.ctlSignature
        ? {
            label: `CTL Signature`,
            value: "",
            image: (
              <ImagePreview
                path={propsData?.consignmentsDetail?.ctlSignature}
              />
            )
          }
        : {},
      propsData?.consignmentsDetail?.guardSignature
        ? {
            label: `Custodian Signature`,
            value: "",
            image: (
              <ImagePreview
                path={propsData?.consignmentsDetail?.guardSignature}
              />
            ),
            style: { marginBottom: "25px" }
          }
        : {},
      {
        label: "Printed on",
        value: moment().format("DD-MMM-YYYY hh:mm A ")
      },
      {
        label: "Printed By",
        value: propsData?.userDetails.DisplayName
      },
      {
        label: "Tel",
        value: "+971 4 703 0500"
      },
      {
        label: "Email",
        value: "info@transguardgroup.com"
      }
    ];

    return _result;
  };
  render() {
    return (
      <div className="col-12">
        <img className="block max-w-[200px] w-full" src={logo} alt="tg-logo" />
        {(this.state as any).data.map((row: any) => {
          if (row.type === "heading") {
            return (
              <h3
                style={{
                  margin: "6x 0 10px 0",
                  font: "normal normal bold 25px/35px DM Sans, arial",
                  letterSpacing: 1.2,
                  ...row.style
                }}
                key={row.label}
              >
                {row.label}
                {row.value ? ` : ${row.value}` : ""}
              </h3>
            );
          }
          return (
            <p
              style={{
                margin: "8px 0",
                font: "normal normal normal 25px/35px DM Sans, arial",
                letterSpacing: 1.2,
                ...row.style
              }}
              key={row.label}
            >
              {row.label}{" "}
              {row.value
                ? ` : ${row.value ? row.value : ""}`
                : row.image
                  ? row.image
                  : ""}
            </p>
          );
        })}
      </div>
    );
  }
}
